// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__65Al_","item":"PaymentsMobile_item__M_eQ2","label":"PaymentsMobile_label__1C_NU","amount":"PaymentsMobile_amount__1zt-t"};